import { spaceDims } from "./spaceDims"

export function gridGen(gridData) {

    const space = spaceDims(gridData.scale, gridData.xInt, gridData.yInt, gridData.height, gridData.width)

    //grid horizontal
    //var ctx = gridData.ctx
    gridData.ctx.clearRect(0, 0, gridData.width, gridData.height)
    for (var i = 0; i < 300; i++){
        gridData.ctx.strokeStyle = '#D6D3D3'
        gridData.ctx.beginPath();
        gridData.ctx.lineWidth = 1
        gridData.ctx.moveTo(0, (gridData.height - space.sy*(i+1)));
        gridData.ctx.lineTo(gridData.width, (gridData.height - space.sy*(i+1)));
        gridData.ctx.stroke();
        gridData.ctx.font = "15px Arial";
        gridData.ctx.fillText(gridData.yInt*(i+1), gridData.width - 20, (gridData.height - space.sy*(i+1))-1);
    }
    //grid vertical
    for (var j = 0; j < space.nx; j++){
        gridData.ctx.beginPath();
        gridData.ctx.moveTo(space.sx*(j+1), 0);
        gridData.ctx.lineTo(space.sx*(j+1), gridData.height);
        gridData.ctx.stroke();
        gridData.ctx.font = "15px Arial";
        gridData.ctx.fillText(gridData.xInt*(j+1), space.sx*(j+1)-4, (gridData.height - 8));
    }
}